import type { ReactNode } from "react";
import { BlockedState } from "./StatePanel.tsx";

type AvailabilityAction = {
	// M3-4: actions can navigate (href) or open an in-place sheet (onClick, e.g.
	// the draft-picks overlay that replaced the retired draft-picks page).
	href?: string;
	onClick?: () => void;
	label: ReactNode;
	variant?: "primary" | "secondary";
};

type Props = {
	actions: AvailabilityAction[];
	children: ReactNode;
	title: ReactNode;
};

export const AvailabilityCard = ({ actions, children, title }: Props) => (
	<BlockedState
		action={
			<div className="d-flex flex-wrap gap-2">
				{actions.map((action, index) => {
					const className = `btn ${
						action.variant === "primary" ? "btn-primary" : "btn-light-bordered"
					}`;
					return action.onClick ? (
						<button
							className={className}
							key={action.href ?? `action-${index}`}
							onClick={action.onClick}
							type="button"
						>
							{action.label}
						</button>
					) : (
						<a className={className} href={action.href} key={action.href ?? `action-${index}`}>
							{action.label}
						</a>
					);
				})}
			</div>
		}
		title={title}
	>
		{children}
	</BlockedState>
);

export default AvailabilityCard;
